import { render } from "./BaseCardBottomButton.vue?vue&type=template&id=b3872d1c&scoped=true"
import script from "./BaseCardBottomButton.vue?vue&type=script&lang=js"
export * from "./BaseCardBottomButton.vue?vue&type=script&lang=js"

import "./BaseCardBottomButton.vue?vue&type=style&index=0&id=b3872d1c&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3872d1c"]])

export default __exports__